import { createTheme } from "@mui/material/styles";
import {
  generalBlack,
  generalDarkGrey,
  petPrimaryGreen,
  petSecondaryGreen,
  beautyPrimaryPurple,
  beautySecondaryPurple,
} from "./colors";
import { ptBR } from "@mui/x-date-pickers/locales";

export const beautyTheme = createTheme(
  {
    palette: {
      primary: {
        main: beautyPrimaryPurple,
      },
      secondary: {
        main: beautySecondaryPurple,
      },
      text: {
        primary: generalBlack,
        secondary: generalDarkGrey,
      },
    },
    typography: {
      fontFamily: `"Roboto", sans-serif`,
      fontSize: 15,
    },
  },
  ptBR
);

export const petTheme = createTheme(
  {
    palette: {
      primary: {
        main: petPrimaryGreen,
      },
      secondary: {
        main: petSecondaryGreen,
      },
      text: {
        primary: generalBlack,
        secondary: generalDarkGrey,
      },
    },
    typography: {
      fontFamily: `"Roboto", sans-serif`,
      fontSize: 15,
    },
  },
  ptBR
);
